module.exports = __webpack_public_path__ + "static/media/MicrosoftAzure.5bed7be9.png";